import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { getAdminUsers } from "../../utils/adminApi";
import {
  formatCellValue,
  normalizeRecord,
  pickValue,
} from "./adminValueUtils";

function AdminUsersSection() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadUsers = async () => {
    try {
      setLoading(true);
      setError("");
      const data = await getAdminUsers();
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setError(err.message || "Неуспешно вчитување на корисници.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  return (
    <Card className="admin-card">
      <CardContent>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={1}
          mb={2}
        >
          <Typography variant="h6">Users</Typography>
          <Button variant="outlined" size="small" onClick={loadUsers}>
            Refresh
          </Button>
        </Stack>

        {error ? <Alert severity="error">{error}</Alert> : null}

        {loading ? (
          <Box className="admin-loading-wrap">
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Box className="admin-table-wrap">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Firebase UID</TableCell>
                  <TableCell>Phone Number</TableCell>
                  <TableCell>Wedding ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((rawUser, index) => {
                  const user = normalizeRecord(rawUser);
                  const userId = pickValue(user, ["id", "user_id", "userId", "uid"]);
                  const email = pickValue(user, ["email", "user_email", "userEmail"]);
                  const firebaseUid = pickValue(user, [
                    "firebase_uid",
                    "firebaseUuid",
                    "firebase_uuid",
                    "firebaseUid",
                    "firebase_id",
                    "firebaseId",
                    "uuid",
                  ]);
                  const phoneNumber = pickValue(user, [
                    "phone_number",
                    "phoneNumber",
                    "mobile",
                    "mobile_number",
                    "mobileNumber",
                    "telephone",
                    "phone",
                  ]);
                  const weddingId = pickValue(user, [
                    "wedding_id",
                    "weddingId",
                  ]);
                  return (
                  <TableRow key={userId || index}>
                    <TableCell>{formatCellValue(userId)}</TableCell>
                    <TableCell>{formatCellValue(email)}</TableCell>
                    <TableCell>{formatCellValue(firebaseUid)}</TableCell>
                    <TableCell>{formatCellValue(phoneNumber)}</TableCell>
                    <TableCell>{formatCellValue(weddingId)}</TableCell>
                  </TableRow>
                  );
                })}
                {users.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5}>Нема корисници.</TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default AdminUsersSection;
